import { jsx as _jsx } from "react/jsx-runtime";
import './PayoutStatistics.css';
import { List } from 'antd';
import CurrencyStatistic from "../CurrencyStatistic/CurrencyStatistic";
const PayoutStatistics = (props) => {
    const renderStatistic = (statistic) => {
        const render = (name) => {
            switch (name) {
                case 'amount':
                    return _jsx(CurrencyStatistic, { amount: statistic.amount });
                case 'count':
                    return statistic.count;
            }
        };
        return statistic.orderBy.map(render);
    };
    return (_jsx(List, { className: `payout-statistics ${props.className}`, size: "small", itemLayout: "horizontal", dataSource: props.statistics, header: props.label, renderItem: (statistic, index) => {
            var _a, _b;
            return (_jsx(List.Item, { actions: renderStatistic(statistic), children: _jsx(List.Item.Meta, { title: props.renderTitle(statistic), avatar: (_a = props.renderAvatar) === null || _a === void 0 ? void 0 : _a.call(props, statistic), description: (_b = props.renderDescription) === null || _b === void 0 ? void 0 : _b.call(props, statistic) }) }, index));
        }, footer: props.footerTitle ? (_jsx(List.Item, { actions: props.footerActions, children: _jsx(List.Item.Meta, { title: props.footerTitle }) })) : null }));
};
export default PayoutStatistics;
